'use strict';

import { Operator } from '../../operator/enum/operator';
import { EntityStatus } from '../enum/entityStatus';
import { ExpirationMaintenance } from '../enum/expirationMaintenance';

export default [
    '$utils',
    '$filterUtils',
    ($utils, $filterUtils) => {
        let filters = getDefaultFilters();
        let sidebarFilters = getDefaultSidebarFilters();

        function getFilters() {
            return angular.copy(filters);
        }

        function setFilters(newFilters) {
            Object.assign(filters, angular.copy(newFilters));
        }

        function getSidebarFilters() {
            return angular.copy(sidebarFilters);
        }

        function setSidebarFilters(newSidebarFilters) {
            Object.assign(sidebarFilters, angular.copy(newSidebarFilters));
        }

        function getDefaultFilters() {
            return {
                milestone: null,
                hasExpirationMaintenance: ExpirationMaintenance.ALL.value,
                industry: [],
            };
        }

        function getDefaultSidebarFilters() {
            return {
                // sidebar filters
                status: null,
                area: null,
                phase: [],
                author: null,
                placeMunicipality: [],
                placeAddress: '',
                manager: null,
                oiv: null,
                curatorOiv: null,
                curatorMizip: null,
                coordorg: null,
                coordinator: null,
                operatorStartSupportYear: Operator.EQ,
                startSupportYear1: null,
                startSupportYear2: null,
                operatorPlanStartYear: Operator.EQ,
                planStartYear1: null,
                planStartYear2: null,
                operatorPlanEndYear: Operator.EQ,
                planEndYear1: null,
                planEndYear2: null,
                okved: null,
                operatorPlanFundsTotal: null,
                planFundsTotal1: null,
                planFundsTotal2: null,
                operatorProfitPlanPaybackPeriod: Operator.EQ,
                profitPlanPaybackPeriod1: null,
                profitPlanPaybackPeriod2: null,
                operatorProfitPlanBudgetPayments: Operator.EQ,
                profitPlanBudgetPayments1: null,
                profitPlanBudgetPayments2: null,
                operatorProfitPlanIrr: Operator.EQ,
                profitPlanIrr1: null,
                profitPlanIrr2: null,
                operatorProfitPlanNpv: Operator.EQ,
                profitPlanNpv1: null,
                profitPlanNpv2: null,
                operatorProfitPlanWplaces: null,
                profitPlanWplaces1: null,
                profitPlanWplaces2: null,
                enableInvestorSearchRequired: false,
                investorSearchRequired: false,
                maintenanceKind: null,
                supportTool: null,
            };
        }

        function getAllFilters() {
            return Object.assign({}, getFilters(), getSidebarFilters());
        }

        function collectFilterDto(filters) {
            let filterDto = {
                milestoneId: filters.milestone,
                statusId: $utils.getValue('status.id', filters),
                hasExpirationMaintenance: filters.hasExpirationMaintenance !== ExpirationMaintenance.ALL.value
                    ? filters.hasExpirationMaintenance === ExpirationMaintenance.EXPIRED.value
                    : null,
                areaId: $utils.getValue('area.id', filters),
                authorId: $utils.getValue('author.id', filters),
                managerId: $utils.getValue('manager.id', filters),
                placeMunicipalityIds: filters.placeMunicipality && filters.placeMunicipality.length ? filters.placeMunicipality.map(item => item.id) : null,
                placeAddress: filters.placeAddress ? filters.placeAddress : null,
                oivId: $utils.getValue('oiv.id', filters),
                curatorOivId: $utils.getValue('curatorOiv.id', filters),
                curatorMizipId: $utils.getValue('curatorMizip.id', filters),
                coordorgId: $utils.getValue('coordorg.id', filters),
                coordinatorId: $utils.getValue('coordinator.id', filters),

                startSupportYear: $filterUtils.getNumericFilter({
                    operator: filters.operatorStartSupportYear,
                    value: filters.startSupportYear1,
                    endValue: filters.startSupportYear2,
                }),
                planStartYear: $filterUtils.getNumericFilter({
                    operator: filters.operatorPlanStartYear,
                    value: filters.planStartYear1,
                    endValue: filters.planStartYear2,
                }),
                planEndYear: $filterUtils.getNumericFilter({
                    operator: filters.operatorPlanEndYear,
                    value: filters.planEndYear1,
                    endValue: filters.planEndYear2,
                }),

                industryIds: filters.industry && filters.industry.length ? filters.industry.map(item => item.id) : null,
                okvedId: $utils.getValue('okved.id', filters),

                planFundsTotal: $filterUtils.getNumericFilter({
                    operator: filters.operatorPlanFundsTotal,
                    value: filters.planFundsTotal1,
                    endValue: filters.planFundsTotal2,
                }),
                profitPlanPaybackPeriod: $filterUtils.getNumericFilter({
                    operator: filters.operatorProfitPlanPaybackPeriod,
                    value: filters.profitPlanPaybackPeriod1,
                    endValue: filters.profitPlanPaybackPeriod2,
                }),
                profitPlanBudgetPayments: $filterUtils.getNumericFilter({
                    operator: filters.operatorProfitPlanBudgetPayments,
                    value: filters.profitPlanBudgetPayments1,
                    endValue: filters.profitPlanBudgetPayments2,
                }),
                profitPlanIrr: $filterUtils.getNumericFilter({
                    operator: filters.operatorProfitPlanIrr,
                    value: filters.profitPlanIrr1,
                    endValue: filters.profitPlanIrr2,
                }),
                profitPlanNpv: $filterUtils.getNumericFilter({
                    operator: filters.operatorProfitPlanNpv,
                    value: filters.profitPlanNpv1,
                    endValue: filters.profitPlanNpv2,
                }),
                profitPlanWplaces: $filterUtils.getNumericFilter({
                    operator: filters.operatorProfitPlanWplaces,
                    value: filters.profitPlanWplaces1,
                    endValue: filters.profitPlanWplaces2,
                }),
                maintenanceKindId: $utils.getValue('maintenanceKind.id', filters),
                supportToolId: $utils.getValue('supportTool.id', filters),
                phaseIds: filters.phase && filters.phase.length ? filters.phase.map(item => item.id) : null,
                entityStatus: EntityStatus.ENABLED,
            };

            if (filters.enableInvestorSearchRequired) {
                filterDto.investorSearchRequired = filters.investorSearchRequired;
            }
            return $utils.removeEmptyFieldsFromObject(filterDto);
        }

        return {
            filters,
            setFilters,
            getFilters,
            getDefaultFilters,

            sidebarFilters,
            setSidebarFilters,
            getSidebarFilters,
            getDefaultSidebarFilters,

            getAllFilters,

            collectFilterDto,
        };
    },
];
